import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { BootstrapInput } from '../../../components/BootstrapInput'
import search from '../../../assets/search.svg'
import { ProductsTableProps } from '../../widgets/productsTable/productsTable'
import { IServerTableData } from '../../../types/tableTypes'
import { ExternalProductModel } from '../../../server/mpsklad_core/Models/ExternalProductModel'

type ProductsTableSearchProps<
  TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string
> = Pick<ProductsTableProps<TProducts, TRow, TColumnId>, 'products'>

export const ProductsTableSearch = <
  TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string
>({products}: ProductsTableSearchProps<TProducts, TRow, TColumnId>) => {
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    setInputValue('')
    products.setGlobalFilter(null)
  }, [products])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    setInputValue(val)
    products.setGlobalFilter(val)
  }

  return (
    <div className={clsx('main_input_container', 'mpcard_input_container')}>
      <BootstrapInput
        placeholder="Название, код или артикул..."
        onChange={onChange}
        inputProps={{'aria-label': 'search'}}
        fullWidth
        style={{marginRight: '20px'}}
        value={inputValue}
      />
      <img className="search-icon" src={search} alt="Поиск"/>
    </div>
  )
}
